import { Spin } from 'antd'
import React from 'react'
import { SpinSize } from 'antd/lib/spin'
import { useScroll } from '~/hooks/useScroll'
import _ from 'lodash'
import styled from 'styled-components'
import classNames from 'classnames'

const ViewWrapper = styled.div`
  .ant-spin-spinning {
    display: block;
    text-align: center;
    color: #ffffff;
    line-height: 1;
  }

  .ant-spin-dot-item {
    background-color: #ffffff;
  }
`

/**
 * @deprecated 不推荐使用，建议用～/hooks/useInfiniteScroll. 不是真的废弃了.
 */
export const InfiniteScroll: React.FC<{
  hasNextPage: boolean
  onScroll: () => void
  loading: boolean
  root?: Element | null
  spinSize?: SpinSize
  spinStyle?: React.CSSProperties
  showLoadingText?: boolean
}> = ({
  hasNextPage,
  onScroll,
  loading,
  root,
  spinSize = 'small',
  spinStyle,
  showLoadingText = true,
}) => {
  const [targetRef] = useScroll({
    onLoadMore: onScroll,
    canLoadMore: hasNextPage,
    root: root,
  })

  return (
    <ViewWrapper ref={targetRef} className="infinite-scroll-element">
      {hasNextPage ? (
        <>
          {loading && (
            <div
              className={classNames(
                'border-neutral-300 border-2 border-solid rounded-full  text-neutral-800 flex items-center justify-between  mx-auto my-6',
                {
                  'w-[122px] py-3 px-4': showLoadingText,
                  'p-3 w-[40px] border-none': !showLoadingText,
                }
              )}
            >
              {showLoadingText && (
                <span className="mr-3 font-semibold !leading-4">正在加载</span>
              )}
              <Spin size={spinSize} style={spinStyle} className="" />
            </div>
          )}
        </>
      ) : null}
    </ViewWrapper>
  )
}
